export default "__VITE_ASSET__Oh46yW9S__"